const NotFound = () => {
    return (
        <div className="FourZeroFour-PageNotFound">
            <div className="FourZeroFour-InnerPage">
                <h1>404</h1> 
                <p>Page not found</p>
            </div>
        </div>    
    );
}
export default NotFound